import numbro from "numbro";
import sv from "numbro/languages/sv-SE";
import { Calc } from "./calc";

numbro.registerLanguage(sv);
numbro.setLanguage(sv.languageTag);

export const formatMiles = (miles: number | string | null) => {
	if (!miles) return null;
	return `${numbro(miles).format({ thousandSeparated: true })} mil`;
};

export const formatCurrency = (value: number | string | null) => {
	if (!value) return null;
	return numbro(value).formatCurrency({ thousandSeparated: true, spaceSeparated: true, mantissa: 0 });
};

export const formatMonthlyCost = (
	value: number,
	months: number,
	rate: number,
	cashDeposit: number,
	restAmount: number
) => {
	if (!value) return null;
	return numbro(Calc.calculateCar(value, cashDeposit, months, rate, restAmount)).formatCurrency({
		mantissa: 0,
		thousandSeparated: true,
		spaceSeparated: true,
		postfix: "/mån",
	});
};
export const effectiveInterest = (
	value: number,
	months: number,
	rate: number,
	cashDeposit: number,
	restAmount: number
) => {
	if (!value) return null;
	const monthlyCost = Calc.calculateCar(value, cashDeposit, months, rate, restAmount);
	const amount = value - value * (cashDeposit / 100);
	const salvagevalueAmount = value * (restAmount / 100);

	return Calc.calculateEffectivRate(amount, months, monthlyCost, salvagevalueAmount).toFixed(2);
};
